import { checkPermission } from '../utils/Roles';
import { incidentAlertColor } from '../utils/utils';


const IncidentLinkButton = ({ handleIncidentOpening = ()=>alert('No function passed'), incident, userRoles }) => {
  const { locked, sealed } = incident || {}
  const canViewLocked = checkPermission(userRoles, "view_locked_incident", "ALL", "", incident?.id)
  const canViewSealed = checkPermission(userRoles, "view_sealed_incident", "ALL", "", incident?.id)
  const disabled = ((!canViewLocked && locked) || (!canViewSealed && sealed)) ? true : false;
  return <button style={disabled
    ? {
      backgroundColor: 'transparent',
      color: '#7d7d7d',
      fontWeight: 'bold',
      fontSize: '1rem',
      border: 'none',
      display: 'inline',
      margin: '0',
      padding: '0',
      '&:hover': {
        textDecoration: 'none'
      },
      '&:focus': {
        textDecoration: 'none'
      },
    }
    : {
      backgroundColor: 'transparent',
      // color: '#6096d1',
      color: incidentAlertColor(incident, true, true, true),
      fontWeight: 'bold',
      fontSize: '1rem',
      border: 'none',
      cursor: 'pointer',
      textDecoration: 'underline',
      display: 'inline',
      margin: '0',
      padding: '0',
      '&:hover': {
        textDecoration: 'none'
      },
      '&:focus': {
        textDecoration: 'none'
      }
    }} data-cy={"tablecell-incident-number-link-" + incident?.id} onClick={disabled ? () => alert('You do not have permission to view this incident') : () => { handleIncidentOpening(incident?.id, true) }}>{incident?.incidentNumber}</button>
}

export default IncidentLinkButton;
